import { IRequesterInfo } from '../../../base/models'
import { ClientProxy } from '../../../base/proxy/clientProxy'
import { IPkDealerRate } from '../models/models'

// Peşine Kontrat taksit oranları. PK'ye uygun olmayan bayi ya da kapalı PK için boş liste döner.
export class ListPkInstallmentApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'posTransaction/listPkInstallment',
      requesterInfo,
    })
  }

  public async listPkInstallment(): Promise<IPkDealerRate[]> {
    return await this.getAsync<IPkDealerRate[]>()
  }
}
